import { Injectable } from '@angular/core';
import { IDeviceModel } from '../models/models';

/**
 * holds the current device models to share between main controls route and subroutes
 * this should only be used in 'dumb' routing components and passed down to the actual components
 */

@Injectable({
    providedIn: 'root'
})
export class CurrentDeviceModelsService {
    private _deviceModels: { [key: string]: IDeviceModel };

    public setCurrentDeviceModels(deviceModels: { [key: string]: IDeviceModel }) {
        this._deviceModels = deviceModels;
    }

    public get deviceModels() {
        return this._deviceModels;
    }
}
